export default {
  title: '产品管理',
  productList: '产品列表',
  addProduct: '新增产品',
  editProduct: '编辑产品',
};
